// extracted by mini-css-extract-plugin
export default {"main":"SkillItem_main__MeQYu","content":"SkillItem_content__H+HwL","arrow":"SkillItem_arrow__RsRSk","skill":"SkillItem_skill__CPBIl"};